<template>
  <div class="pd-t140 main theme-style-01">

    <!-- 栏目页面区 begin -->
    <transition enter-active-class="bounceInRight">
      <router-view class="animated"></router-view>
    </transition>
    <!-- 栏目页面区 end -->
  </div>
</template>

<script>
  import crumb from './crumb'
	export default {
		name: "Main",

    components: {
      crumb
    },

    computed: {
      getRouteInfo() {

        return this.$route.path
      },

      getTreeData() {
        return this.$store.state.menuList
      },

      getRouterInfo() {
        let routerInfo = this.$route;
        let crumbList = [];

        routerInfo.meta ? crumbList = routerInfo.meta.crumbList : '';

        return crumbList
      }
    },

    data() {
      return {
        transitionName: '',
        crumbList: [], // 面包屑菜单
        menuList: [],
        menuTree: [],
      }
    },

    watch: {
      $route(to, from) {
        if(to.meta.index < from.meta.index){
          this.names = "el-zoom-in-center"
        } else {
          this.names = "el-zoom-in-center"
        }
      }
    },

    mounted() {

      // this.getUserInfo();
      let menuScrollBox = $('#menu-scroll-box');
      menuScrollBox.mCustomScrollbar({
        set_width: false,
        set_height: false,
        // horizontalScroll: false,
        axis:"y",
        scrollInertia: 100, // 滚动条惯性(值越大惯性越大)
        scrollEasing: "easeOutCirc",
        mouseWheel: true, //
        autoDraggerLength: true,
        scrollButtons: {
          enable: false,
          scrollType: "continuous",
          scrollSpeed: 20,
          scrollAmount: 20
        },
        advanced:{
          updateOnBrowserResize: true,
          updateOnContentResize: true,
          autoExpandHorizontalScroll: true,
          autoScrollOnFocus: true
        },
        callbacks:{
          onScrollStart: function(){},
          onScroll: function(){},
          onTotalScroll: function(){},
          onTotalScrollBack: function(){},
          onTotalScrollOffset: 0,
          whileScrolling: false,
          whileScrollingInterval: 10
        }
      });
    }
	}
</script>

<style>

</style>
